// extracted by mini-css-extract-plugin
export default {"boxes":"boxesViev_boxes__cGtMk","outside":"boxesViev_outside__H46+r","sentence":"boxesViev_sentence__-LQ2k","slider":"boxesViev_slider__WuUMS","image":"boxesViev_image__3vXDT"};